import FormExternalOwnerContainer from './FormExternalOwner.container';
export default FormExternalOwnerContainer;
